export default function isUzb() {
  return localStorage.getItem('isUzb') === 'true';
}
